import React from 'react';
import Icon from './Icon';

interface FullScreenLoaderPropsBase {
  hideBg?: boolean;
}

type FullScreenLoaderProps = FullScreenLoaderPropsBase & React.HTMLAttributes<HTMLDivElement>;

export function FullScreenLoader(props: FullScreenLoaderProps) {
  const { hideBg, className: propClasses, ...rest } = props;

  const classes = ['absolute top-0 left-0 w-full h-full z-50 grid items-center justify-center'];
  if (!hideBg) classes.push('bg-white');
  if (propClasses) classes.push(propClasses);

  return (
    <div {...rest} className={classes.join(' ')}>
      <Icon icon={['fass','circle-notch']} spin />
    </div>
  );
}
